import { Alert } from '@mantine/core'
import { AlertTriangle } from 'lucide-react'

interface FetchErrorProps {
  error?: Error | string
  title?: string
}

export function FetchError({
  error,
  title = 'Erro inesperado'
}: FetchErrorProps) {
  const getErrorMessage = () => {
    if (!error) {
      return 'Ocorreu um erro inesperado'
    }
    if (typeof error === 'string') {
      return error
    }
    return error.message || 'Ocorreu um erro inesperado'
  }
  return (
    <Alert
      title={title}
      variant="light"
      color="red"
      className="max-w-xl"
      icon={<AlertTriangle />}
    >
      {getErrorMessage()}
    </Alert>
  )
}
